/**
 * Task
 *  タスク関連
 */

import task from "../../api/task"

export default {
  namespaced: true,
  state: {
    taskList: [],
    isFileChanging: false,
    taskLog: [],
    trelloBoard: [],
    trelloLoading: false,
    getTrelloTask: false,
    isBoard: false,
    trelloBoardList: [],
    trelloListList: [],
    trelloCardList: [],
  },
  actions: {
    // UserTask API
    createUserTask ({commit}, data) {
      return task.createUserTask(data)
        .then((d) => {
          // タスクを他人に送付する以外は作成
          if (!data.is_send) {
            commit('CREATE_TASK', d.data)
          }
          return d.data
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    getUserTask ({commit}, pk) {
      task.getUserTask(pk)
        .then((d) => {
          commit('GET_TASK', d.data)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    updateUserTask ({commit}, data) {
      return task.updateUserTask(data)
        .then((d) => {
          commit('UPDATE_TASK', d.data)
          return d.data
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    deleteUserTask ({commit}, id) {
      task.deleteUserTask(id)
        .then((d) => {
          commit('DELETE_TASK', id)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    // UserTaskFile API
    createUserTaskFile ({commit}, data) {
      commit('FILE_CHANGING', true)
      task.createUserTaskFile(data)
        .then((d) => {
          commit('CREATE_TASK_FILE', d.data)
          commit('FILE_CHANGING', false)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    updateUserTaskFile ({commit}, data) {
      commit('FILE_CHANGING', true)
      task.updateUserTaskFile(data)
        .then((d) => {
          commit('UPDATE_TASK_FILE', d.data)
          commit('FILE_CHANGING', false)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    deleteUserTaskFile ({commit}, id) {
      commit('FILE_CHANGING', true)
      task.deleteUserTaskFile(id)
        .then((d) => {
          commit('DELETE_TASK_FILE', id)
          commit('FILE_CHANGING', false)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    // UserTaskLog API
    createUserTaskLog ({commit}, data) {
      return task.createUserTaskLog(data)
        .then((d) => {
          commit('CREATE_TASK_LOG', d.data)
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    updateUserTaskLog ({commit}, data) {
      return task.updateUserTaskLog(data)
        .then((d) => {
          commit('UPDATE_TASK_LOG', d.data)
          return d.data
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    createLinkTrelloAPI ({commit}, data) {
      commit('TRELLO_LOADING', true)
      return task.createLinkTrelloAPI(data)
        .then((d) => {
          commit('CREATE_LINK_TRELLO_API', d.data)
          return d.data
        })
        .catch((e) => {
          commit('TRELLO_LOADING', false)
          alert('入力されたキーが正しいか確認してください')
          console.error(e)
          return
        })
    },
    createLinkTrelloBoard ({commit}, {data, data2}) {
      commit('GET_TRELLO_LOADING', true)
      return task.createLinkTrelloBoard({data, data2})
        .then((d) => {
          commit('CREATE_LINK_TRELLO_BOARD', d.data)
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('連携できませんでした')
          return
        })
    }, 
    getTrelloCard ({commit}, pk) {
      return task.getTrelloCard(pk)
        .then((d) => {
          commit('GET_TRELLO_CARD', d.data)
          return d.data
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getTrelloList ({commit}, data) {
      return task.getTrelloList(data)
        .then((d) => {
          commit('GET_TRELLO_LIST', d.data)
          return d.data
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getTrelloBoard ({commit}, data) {
      return task.getTrelloBoard(data)
        .then((d) => {
          commit('GET_TRELLO_BOARD', d.data)
          return d.data
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getTrelloLoading ({commit}, flg) {
      commit('GET_TRELLO_LOADING', flg)
    },
    isBoard ({commit}, flg) {
      commit('IS_BOARD', flg)
    },
  },
  mutations: {
    // UserTask API
    CREATE_TASK (state, data) {
      state.taskList.push(data)
    },
    GET_TASK (state, data) {
      state.taskList = []
      state.trelloCardList = [] 
      for (let i of data) {
        if (i.trello_id == null) {
          state.taskList.push(i)
        } else {
          state.trelloCardList.push(i)
        }
      }
    },
    UPDATE_TASK (state, data) {
      for (let i in state.taskList) {
        if (state.taskList[i].pk == data.pk) {
          state.taskList.splice(i, 1, data)
          return
        }
      }
      for (let i in state.trelloCardList) {
        if (state.trelloCardList[i].pk == data.pk) {
          state.trelloCardList.splice(i, 1, data)
          return
        }
      }

    },
    DELETE_TASK (state, pk) {
      for (let i in state.taskList) {
        if (state.taskList[i].pk == pk) {
          state.taskList.splice(i, 1)
          return
        }
      }
      for (let i in state.trelloCardList) {
        if (state.trelloCardList[i].pk == pk) {
          state.trelloCardList.splice(i, 1)
          return
        }
      }
    },
    // UserTaskFile API
    CREATE_TASK_FILE (state, data) {
      for (let i in state.taskList) {
        if (state.taskList[i].pk == data.user_task) {
          state.taskList[i].user_task_file.push(data)
          return
        }
      }
    },
    UPDATE_TASK_FILE (state, data) {
      for (let i in state.taskList) {
        for (let j in state.taskList[i].user_task_file) {
          if (state.taskList[i].user_task_file[j].pk == data.pk) {
            state.taskList[i].user_task_file.splice(j, 1, data)
            return
          }
        }
      }
      for (let i in state.trelloCardList) {
        for (let j in state.trelloCardList[i].user_task_file) {
          if (state.trelloCardList[i].user_task_file[j].pk == data.pk) {
            state.trelloCardList[i].user_task_file.splice(j, 1, data)
            return
          }
        }
      }
    },
    DELETE_TASK_FILE (state, pk) {
      for (let i in state.taskList) {
        for (let j in state.taskList[i].user_task_file) {
          if (state.taskList[i].user_task_file[j].pk == pk) {
            state.taskList[i].user_task_file.splice(j, 1)
            return
          }
        }
      }
      for (let i in state.trelloCardList) {
        for (let j in state.trelloCardList[i].user_task_file) {
          if (state.trelloCardList[i].user_task_file[j].pk == pk) {
            state.trelloCardList[i].user_task_file.splice(j, 1)
            return
          }
        }
      }

    },
    FILE_CHANGING (state, flg) {
      state.isFileChanging = flg
    },
    // UserTaskLog API
    CREATE_TASK_LOG (state, data) {
      // 一つだけ更新
      for (let i in state.taskList) {
        if (state.taskList[i].pk == data.user_task) {
          state.taskList[i].user_task_log.push(data)
          return
        }
      }
    },
    UPDATE_TASK_LOG (state, data) {
      // 一つだけ更新
      for (let i in state.taskList) {
        for (let j in state.taskList[i].send_user_task_log) {
          if (state.taskList[i].send_user_task_log[j].id == data.id) {
            state.taskList[i].send_user_task_log.splice(j, 1, data)
            return
          }
        }
      }
    },
    CREATE_LINK_TRELLO_API (state, data) {
      state.trelloBoard = data
      state.trelloLoading = false
    },
    TRELLO_LOADING (state, flg) {
      state.isBoard = flg
      state.trelloLoading = flg
    },
    CREATE_LINK_TRELLO_BOARD (state, data) {
      // state.trelloBoardList = data
      state.getTrelloTask = true
    },
    GET_TRELLO_CARD (state, data) {
      state.trelloCardList = data
    },
    GET_TRELLO_LIST (state, data) {
      state.trelloListList = data
    },
    GET_TRELLO_BOARD (state, data) {   
      state.trelloBoardList = data
    },
    GET_TRELLO_LOADING (state, flg) {
      state.getTrelloTask = flg
    },
    IS_BOARD(state, flg) {
      state.isBoard = flg
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/task.js